import { render, staticRenderFns } from "./TrendingPage.vue?vue&type=template&id=d7bc8544&"
import script from "./TrendingPage.vue?vue&type=script&lang=js&"
export * from "./TrendingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports